import { RouteConfig } from 'vue-router'
import { requireAuthAndLocation } from '../../auth'
import { transactionsRouteNames } from '@/routes/constants/location'

const Transactions = () => import('@/pmd/pages/payments/v2/Transactions.vue')
const TransactionDetailsApp = () => import('@/pmd/pages/payments/v2/TransactionsDetails.vue')

export const TransactionsRoute: RouteConfig[] = [
  {
    path: 'payments/v2/transactions',
    name: transactionsRouteNames.transactions,
    component: Transactions,
    beforeEnter: requireAuthAndLocation,
    children: [],
  },
  {
    path: 'payments/v2/transactions/:transactionId',
    name: transactionsRouteNames.transactionDetails,
    component: TransactionDetailsApp,
    beforeEnter: requireAuthAndLocation,
    children: [],
  },
]
